import {
  ACTIVITY_TYPE,
  isWheelOfFortuneActivityType,
  isVideoActivityType,
  isFreeKickActivityType,
  isBackgammonActivityType
} from '@/types/Activity';
import {ROUTES} from '@/utils/constants/routesConstants';

export const getProgressConfig = (activityType) => {
  if (
    isWheelOfFortuneActivityType(activityType) ||
    isFreeKickActivityType(activityType) ||
    isBackgammonActivityType(activityType)
  ) {
    return {
      steps: 4,
      titles: [
        {title: 'Setup'},
        {title: 'Display'},
        {title: 'Attributes'},
        {title: 'Review'}
      ]
    };
  }
  if (activityType === ACTIVITY_TYPE.SURVEY) {
    return {
      steps: 3,
      titles: [{title: 'Setup'}, {title: 'Attributes'}, {title: 'Review'}]
    };
  }
  if (isVideoActivityType(activityType)) {
    return {
      steps: 3,
      titles: [{title: 'Setup'}, {title: 'Display'}, {title: 'Review'}]
    };
  }
  if (isFreeKickActivityType(activityType)) {
    return {
      steps: 3,
      titles: [{title: 'Setup'}, {title: 'Display'}, {title: 'Review'}]
    };
  }
  return {
    steps: 2,
    titles: [{title: 'Setup'}, {title: 'Review'}]
  };
};

export const getProgressRoute = (activityType, step) => {
  if (isWheelOfFortuneActivityType(activityType)) {
    return (
      {
        2: ROUTES.ACTIVITY_DISPLAY,
        3: ROUTES.ACTIVITY_ATTRIBUTES,
        4: ROUTES.ACTIVITY_REVIEW
      }[step] || undefined
    );
  }
  if (isBackgammonActivityType(activityType)) {
    return (
      {
        2: ROUTES.ACTIVITY_DISPLAY,
        3: ROUTES.ACTIVITY_ATTRIBUTES,
        4: ROUTES.ACTIVITY_REVIEW
      }[step] || undefined
    );
  }
  if (activityType === ACTIVITY_TYPE.SURVEY) {
    return (
      {
        2: ROUTES.ACTIVITY_ATTRIBUTES,
        3: ROUTES.ACTIVITY_REVIEW
      }[step] || undefined
    );
  }
  if (isVideoActivityType(activityType)) {
    return (
      {
        2: ROUTES.ACTIVITY_DISPLAY,
        3: ROUTES.ACTIVITY_REVIEW
      }[step] || undefined
    );
  }
  return (
    {
      2: ROUTES.ACTIVITY_REVIEW
    }[step] || undefined
  );
};

export const getNextRoute = (
  activityType,
  isVideoActivity,
  isFreeKickGameActivity,
  isWheelOfFortuneActivity,
  isBackgammonGameActivity
) => {
  if (activityType === ACTIVITY_TYPE.SURVEY) return ROUTES.ACTIVITY_ATTRIBUTES;
  if (
    isVideoActivity ||
    isFreeKickGameActivity ||
    isWheelOfFortuneActivity ||
    isBackgammonGameActivity
  )
    return ROUTES.ACTIVITY_DISPLAY;
  return ROUTES.ACTIVITY_REVIEW;
};
